export default setup => {
  let handler

  const keys = new Map()
  const onKey = function (ev) {
    keys.set(ev.key, ev.type === 'keydown')

    Object.entries(setup).forEach(([target, func]) => {
      if (!target.split('+').every(k => keys.get(k))) return
      func.call(this, this)
    })
  }

  return {
    created() {
      handler = onKey.bind(this)
      document.addEventListener('keydown', handler)
      document.addEventListener('keyup', handler)
    },
    beforeDestroy() {
      document.removeEventListener('keydown', handler)
      document.removeEventListener('keyup', handler)
    },
  }
}
